


















































import { List } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { getId, getRouteName } from "@/config/cookies";
import { OrderDetail } from "@/api/interface";
import { orderDetail } from "@/api/factory";
@Component({
  components: {
    List,
  },
})
export default class extends Vue {
  private form: Array<object> = [];
  private params: OrderDetail = {
    openId: getId(),
    id: "",
    factory_id: "",
    create_time: "",
  };
  private id: any = "";
  private factory_id: any = "";
  private isLoading: boolean = false;
  private loading: boolean = false;
  private finished: boolean = false;

  private onRefresh() {
    setTimeout(() => {
      this.getData();
      this.$toast("刷新成功");
      this.isLoading = false;
    }, 1000);
  }

  private onLoad() {
    setTimeout(() => {
      this.finished = true;
    }, 1000);
  }

  private mounted() {
    this.params.id = this.$route.query.id;
    this.params.factory_id = this.$route.query.factory_id;
    this.params.create_time = this.$route.query.create_time;
    this.getData();
  }

  //跳转确认收货
  private receiptPhoto(item: any) {
    this.$router.push({
      name: "receiptPhoto",
      query: {
        order_no: item.order_no,
        app_order_id: item.app_order_id,
        factory_id: this.params.factory_id,
      },
    });
  }

  private async getData() {
    const res: any = await orderDetail(this.params);
    if (res.status) {
      let data: any = res.data.returnData;
      this.form = data.sellReportDetail;
      if (data.sellReportDetail.length == 0) {
        this.form = data.purReportDetail;
      }
    } else {
      this.$notify({ type: "warning", message: res.info });
    }
  }
}
